import { isActiveModuleEnabled, isModuleEnabled } from './companyProfile';
import {
  PATH_ACTIVE_MODULE,
  TAB_ACTIVE_MODULE,
  TAB_ENABLED_MODULE,
  dashboardTabFromPathname,
} from './dashboardRoutes';

/**
 * Whether a dashboard tab is unlocked for the current company workspace.
 * @param {import('./companyProfile').mapCompanyWorkspaceData extends (...args: any) => infer R ? R : never} workspace
 * @param {string} tabId
 * @param {{ loading?: boolean }} [options]
 */
export function isDashboardTabAccessible(workspace, tabId, options = {}) {
  if (options.loading) return true;

  const activeKey = TAB_ACTIVE_MODULE[tabId];
  if (activeKey && !isActiveModuleEnabled(workspace, activeKey)) {
    return false;
  }

  const enabledKey = TAB_ENABLED_MODULE[tabId];
  if (enabledKey && !isModuleEnabled(workspace, enabledKey)) {
    return false;
  }

  return true;
}

/**
 * @param {string} pathname
 * @param {object | null | undefined} workspace
 * @param {{ loading?: boolean }} [options]
 */
export function isDashboardPathAccessible(pathname, workspace, options = {}) {
  if (options.loading) return true;

  const path = pathname.replace(/\/$/, '') || '/dashboard';
  const moduleKey = PATH_ACTIVE_MODULE[path];
  if (moduleKey && !isActiveModuleEnabled(workspace, moduleKey)) {
    return false;
  }

  const tabId = dashboardTabFromPathname(pathname);
  if (!tabId) return true;

  return isDashboardTabAccessible(workspace, tabId, { loading: false });
}

/**
 * @param {string} tabId
 * @returns {string | null}
 */
export function activeModuleKeyForTab(tabId) {
  return TAB_ACTIVE_MODULE[tabId] || null;
}
